export default "/images/error_image.webp"